import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {MdKeyboardArrowDown} from 'react-icons/md';
import { GiHamburgerMenu } from "react-icons/gi";
import { RxHamburgerMenu } from "react-icons/rx";



import InfoPage from '../info/InfoPage';
import '../../styles/header.scss';
import {ProfileMenu} from '../ProfileMenu';

const HeaderUserDash = ({setIsOpenAside}) => {
  const [isInfo, setIsInfo] = useState(false);
  const [isNotification, setIsNotification] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsNotification(true);
    }, 1000);
  }, []);
  //   onClick={() => setIsOpenAside(state => !state)}
  return (
    <div className="header_user_wrap header_dashboard_wrap">
      <div className="header_dashboard_wrap_burger">
        {/* <img onClick={() => setIsOpenAside((state) => !state)} src="/img/header/menu.svg" alt="" /> */}
        <RxHamburgerMenu style={{maxHeight:'50px', maxWidth:'50px', width:'100%', height:'100%'}} onClick={() => setIsOpenAside((state) => !state)}  />

      </div>
      <Link to="/">
        <div className="logo_wraper">
          <img src="/img/Logo.svg" alt="Logo" />
        </div>
      </Link>
      <div className="profile_menu_wraper">
        <img className="profile_menu_wraper_pro" src="/img/header/Moon.svg" alt="" />
        <img
          className="profile_menu_wraper_info"
          src="/img/header/Information.svg"
          alt="Information.svg"
          onClick={() => setIsInfo((state) => !state)}
        />
        <Link to="/notification">
          <div className="notifications_wrap">
            <img src="../img/header/Notifications.svg" alt="Notifications.svg" />
            <div className="notifications_triger"></div>
          </div>
        </Link>

        {/* <div className="profile_icon">
          <div className="img_hero_wrap">
            <img src="/img/header/Plug.svg" alt="Plug.svg" />
          </div>
          <div className="profile_dropdown">
            <MdKeyboardArrowDown />
          </div>
        </div> */}
        <ProfileMenu />
      </div>
      {isInfo && <InfoPage setIsInfo={setIsInfo} />}
    </div>
  );
};

export default HeaderUserDash;
